import React, { useEffect, useState } from "react";
import { Row, Col } from "react-bootstrap";
import { motion, AnimatePresence } from "framer-motion";
import { ChevronLeft, ChevronRight } from "lucide-react";

import image1 from "../../Image/01.jpg";
import image2 from "../../Image/02.jpg";
import image3 from "../../Image/03.jpg";

import QuickLinksTabs from "../../Pages/QuickLinksTabs";
import tabContent from "../../resources/quickLinksData.json";

import Teachers_day_001 from "../../Image/Teachers_day_001.jpeg";
import Teachers_day_002 from "../../Image/Teachers_day_002.jpeg";
import Teachers_day_003 from "../../Image/Teachers_day_003.jpeg";
import Teachers_day_004 from "../../Image/Teachers_day_004.jpeg";
import Teachers_day_005 from "../../Image/Teachers_day_005.jpeg";

import image7 from "../../Image/07.jpg";
import image8 from "../../Image/08.jpg";
import image9 from "../../Image/09.jpg";



const styles = {
  heroWrapper: {
    position: "relative",
    height: "480px",
    borderRadius: "18px",
    overflow: "hidden",
  },

  heroImage: {
    width: "100%",
    height: "100%",
    objectFit: "cover",
    position: "absolute",
    inset: 0,
  },

  overlay: {
    position: "absolute",
    inset: 0,
    background:
      "linear-gradient(to top, rgba(0,0,0,0.65), rgba(0,0,0,0.25), transparent)",
  },

  textWrapper: {
    position: "absolute",
    bottom: "50px",
    left: "50px",
    maxWidth: "70%",
    color: "#fff",
    zIndex: 2,
  },

  title: {
    fontSize: "38px",
    fontWeight: 700,
    marginBottom: "8px",
  },

  subtitle: {
    fontSize: "18px",
    opacity: 0.9,
  },

  navBtn: (side) => ({
    position: "absolute",
    top: "50%",
    [side]: "20px",
    transform: "translateY(-50%)",
    width: "44px",
    height: "44px",
    borderRadius: "50%",
    background: "#fff",
    border: "none",
    cursor: "pointer",
    display: "flex",
    alignItems: "center",
    justifyContent: "center",
    boxShadow: "0 6px 16px rgba(0,0,0,0.25)",
    zIndex: 3,
  }),

  dots: {
    position: "absolute",
    bottom: "18px",
    left: "50%",
    transform: "translateX(-50%)",
    display: "flex",
    gap: "8px",
    zIndex: 3,
  },

  dot: {
    height: "8px",
    background: "#fff",
    borderRadius: "6px",
    cursor: "pointer",
    transition: "all 0.3s ease",
  },
};

const slides = [
  { image: Teachers_day_001, title: "Celebrate Teachers", subtitle: "Teachers Day Celebration" },
  { image: Teachers_day_002, title: "Celebrate Teachers", subtitle: "Teachers Day Celebration" },
   { image: Teachers_day_003, title: "Celebrate Teachers", subtitle: "Teachers Day Celebration" },
{ image: image7, title: "Student Success", subtitle: "Shaping leaders of tomorrow" },
  { image: image8, title: "Global Exposure", subtitle: "Preparing students for the world" },
 { image: image9, title: "Community Engagement", subtitle: "Education with social responsibility" },
 ];

const AUTO_PLAY = 5000;

const ImageSlider = () => {
  const [index, setIndex] = useState(0);

  const next = () => setIndex((i) => (i + 1) % slides.length);
  const prev = () => setIndex((i) => (i - 1 + slides.length) % slides.length);

  useEffect(() => {
    const timer = setInterval(next, AUTO_PLAY);
    return () => clearInterval(timer);
  }, []);

  return (
    <Row className="g-3">
      {/* ===== HERO CAROUSEL ===== */}
      <Col xs={12} md={8}>
        <div style={styles.heroWrapper}>
          <AnimatePresence mode="wait">
            <motion.img
              key={slides[index].image}
              src={slides[index].image}
              alt="slide"
              initial={{ opacity: 0, scale: 1.05 }}
              animate={{ opacity: 1, scale: 1 }}
              exit={{ opacity: 0, scale: 1.05 }}
              transition={{ duration: 0.8 }}
              style={styles.heroImage}
            />
          </AnimatePresence>

          {/* 🔥 SINGLE overlay (not split) */}
          <div style={styles.overlay} />

          {/* Text ON image */}
          <AnimatePresence mode="wait">
            <motion.div
              key={slides[index].title}
              initial={{ opacity: 0, y: 30 }}
              animate={{ opacity: 1, y: 0 }}
              exit={{ opacity: 0, y: 30 }}
              transition={{ duration: 0.6 }}
              style={styles.textWrapper}
            >
              <h1 style={styles.title}>{slides[index].title}</h1>
              <p style={styles.subtitle}>{slides[index].subtitle}</p>
            </motion.div>
          </AnimatePresence>

          {/* Arrows */}
          <button style={styles.navBtn("left")} onClick={prev}>
            <ChevronLeft size={26} />
          </button>
          <button style={styles.navBtn("right")} onClick={next}>
            <ChevronRight size={26} />
          </button>

          {/* Dots */}
          <div style={styles.dots}>
            {slides.map((_, i) => (
              <span
                key={i}
                style={{
                  ...styles.dot,
                  width: index === i ? "22px" : "8px",
                  opacity: index === i ? 1 : 0.4,
                }}
                onClick={() => setIndex(i)}
              />
            ))}
          </div>
        </div>
      </Col>

      {/* ===== QUICK LINKS ===== */}
      <Col xs={12} md={3}>
        <QuickLinksTabs tabContent={tabContent} />
      </Col>
    </Row>
  );
};

export default ImageSlider;
